import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { ServicesMarquee } from "@/components/ServicesMarquee";
import { Services } from "@/components/Services";
import { Structures } from "@/components/Structures";
import { MapSection } from "@/components/MapSection";
import { Careers } from "@/components/Careers";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { PrivacyPage } from "@/components/PrivacyPage";
import { Toaster } from "@/components/ui/sonner";

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Manifesto />
      <ServicesMarquee />
      <Services />
      <Structures />
      <MapSection />
      <Careers />
      <ContactForm />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="bg-cream text-ink font-sans min-h-screen">
          <div className="grain-overlay" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
